const colors = require('tailwindcss/colors');

module.exports = {
  content: ['./src/**/*.{tsx,jsx,ts,js,sass}', './public/index.html'],
  safelist: ['w-5', 'h-5', 'bg-primary-800'],
  theme: {
    // defaults taken from docs: https://tailwindcss.com/docs/responsive-design
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px',
      '3xl': '1850px'
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: colors.white,
      black: colors.black,
      gray: '#98a2a8',
      'off-gray': '#FDFDFD',
      'navy-dark': '#031632',
      navy: '#092043',
      'off-navy': '#CFD5D8',
      blue: '#4D9DE0',
      'off-blue': '#DBEBF9',
      neutral: {
        50: '#f8fbfc',
        100: '#f5f9fb',
        150: '#edf3f5',
        200: '#e0e7eb',
        400: '#a3a3a3',
        500: '#7A86A1'
      },
      primary: {
        40: '#E1F7FC',
        45: '#D4E6FF',
        50: '#5DDDFF',
        100: '#01BAEC',
        200: '#659aea',
        300: '#544CEC',
        400: '#1856b5',
        500: '#164791',
        600: '#0e3269',
        700: '#092043',
        800: '#071b38'
      },
      secondary: {
        50: '#EDECFE',
        100: '#9893f3',
        200: '#8079FF',
        300: '#766fef',
        400: '#655ded',
        600: '#2217e1',
        700: '#1d14c5',
        800: '#1911a9'
      },
      tertiary: {
        50: '#F0FCF9',
        200: '#D0F2E8',
        300: '#A4F1E0',
        400: '#7CE5D1',
        500: '#6BC8A5',
        600: '#05BF9A'
      },
      success: {
        50: '#C5FBEF',
        100: '#8CF8E0',
        200: '#1AF2C2',
        400: '#04D2A4'
      },
      warning: {
        100: '#FFF2D5',
        200: '#FFEFCB',
        600: '#F9AB00',
        700: '#C28500',
        800: '#8C6200'
      },
      error: {
        75: '#FEE9E9',
        100: '#FEE2E2',
        150: '#FCC5D1',
        300: '#F2337D'
      }
    },
    fontFamily: {
      sans: ['Proxima Nova', 'sans-serif']
    },
    fontSize: {
      xxxs: '0.5rem',
      xxs: '0.65rem',
      xs: '0.75rem',
      sm: '0.875rem',
      base: '10px',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '4rem',
      '7xl': '5rem',
      '8xl': '6rem'
    },
    extend: {
      keyframes: {
        flash: {
          '0%': { opacity: '0' },
          '50%': { opacity: '1' },
          '100%': { opacity: '0.85' }
        },
        loading: {
          '0%': { left: 0, transform: 'translateX(0)' },
          '100%': { left: '100%', transform: 'translateX(-100%)' }
        },
        'in-from-right': {
          from: {
            transform: 'translateX(100%)'
          },
          to: {
            transform: 'translateX(0)'
          }
        }
      },
      animation: {
        flash: 'flash 1s ease-in-out',
        loading: 'loading 1s ease-in-out infinite alternate',
        'spin-600': 'spin .600s linear infinite',
        'in-from-right': 'in-from-right 300ms ease-in-out'
      },
      spacing: {
        7.5: '1.85rem',
        13: '3.25rem',
        14: '3.5rem',
        15: '3.75rem',
        18: '4.5rem',
        19: '4.75rem',
        21: '5.25rem',
        22: '5.5rem',
        25: '6.25rem',
        30: '7.5rem',
        40: '10rem',
        44: '11rem',
        60: '15rem',
        69: '17.25rem',
        72: '18rem',
        80: '20rem',
        85: '21.25rem',
        86: '21.50rem',
        87: '21.75rem',
        88: '22rem',
        92: '23rem',
        108: '27rem',
        128: '32rem',
        144: '36rem'
      },
      height: {
        128: '32rem',
        '2/3-screen': '66vh'
      },
      minHeight: {
        '1/2-screen': '50vh'
      },
      maxHeight: {
        128: '32rem',
        '2/3-screen': '66vh'
      },
      maxWidth: {
        60: '15rem',
        108: '27rem'
      },
      borderRadius: {
        DEFAULT: '0.375rem',
        sm: '0.125rem',
        lg: '0.5rem',
        full: '9999px',
        '4xl': '2rem',
        '1/2': '50%'
      },
      zIndex: {
        999: '999'
      },
      scale: {
        30: '0.3'
      }
    }
  },
  extend: {
    fontSize: {
      xxs: '0.625rem'
    }
  }
};
